import { useState } from 'react'
import methodModel from '../../../methods/methods'
import SelectDropdown from '../SelectDropdown'
import './style.scss'
import { Editor } from "@tinymce/tinymce-react";
import tinymcModel from '../../../models/tinymc.model';
import ReactQuill from 'react-quill';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

export default function FormControl({
    name,
    divClass = null,
    className = "",
    labelClass = "",
    id = "",
    displayValue = 'name',
    sort = true,
    placeholder = "",
    type = 'text',
    options = [],
    error,
    label,
    required = false,
    onInputChange = (e) => { },
    onChange,
    maxlength = '',
    minlength = '',
    min = '',
    value,
    theme = '',
    disabled = false,
    autoComplete = 'off',
    showEye = false
}) {
    const [showPassword, setShowPassword] = useState(false)


    const [text, setText] = useState('')

    const add = () => {
        let arr = value || []
        if (text) {
            arr.push(text)
        }
        onChange(arr)
        setText('')
    }

    const remove = (i) => {
        let arr = value || []
        arr = arr.filter((itm, index) => index != i)
        onChange(arr)
    }

    const addItem = (v) => {
        let arr = value || []
        let ext = arr?.find((itm) => itm == v)

        if (ext) {
            arr = arr.filter(itm => itm != v)
        } else {
            arr.push(v)
        }

        onChange(arr)
    }

    return <>
        <div className={`formWrapper ${divClass || ''}`}>
            {label ? <>
                <label className={`text-sm font-semibold text-slate-800 !mb-2 inline-block ${labelClass}`}>{label} {required ? <><span className="text-red-500">*</span></> : <></>}</label>
            </> : <></>}

            {type == 'toggle' ? <>
                <div>
                    <label class="inline-flex items-center cursor-pointer">
                        <input type="checkbox" checked={value} onChange={e => onChange(e.target.checked)} value="" class="sr-only peer" />
                        <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#115B9D]"></div>
                    </label>
                </div>



            </> : type == 'textarea' ? <>
                <textarea rows={5}
                    name={name}
                    className={`relative shadow-box ${error ? 'border-[1.5px] border-red-500' : 'border-[1.5px] border-slate-500'} bg-white w-full rounded-large flex items-center gap-2 overflow-hidden p-3 outline-none focus:outline-none focus:ring-0 ${error ? 'focus:border-red-500' : 'focus:border-slate-500'} text-sm text-slate-900 ${className}`}
                    required={required}
                    placeholder={placeholder}
                    value={value || ''}
                    maxLength={maxlength}
                    minLength={minlength}
                    min={min}
                    disabled={disabled}
                    onChange={e => onChange(e.target.value)}
                ></textarea>
            </> : type == 'select' ? <SelectDropdown
                id={`statusDropdown_${id}`}
                displayValue={displayValue}
                placeholder={placeholder}
                sort={sort}
                onInputChange={onInputChange}
                intialValue={value || ''}
                name={name}
                theme={theme}
                result={e => { onChange(e.value) }}
                options={options}
                disabled={disabled}
            /> : type == 'number' ? <input
                type="text"
                name={name}
                className={`shadow-box ${error ? 'border-[1.5px] border-red-500' : 'border-[1.5px] border-slate-500'} bg-white w-full text-sm text-slate-900 placeholder:text-gray-400 rounded-large h-10 flex items-center gap-2 overflow-hidden px-4 outline-none focus:outline-none focus:ring-0 ${error ? 'focus:border-red-500' : 'focus:border-slate-500'} relative ${className}`}
                required={required}
                placeholder={placeholder}
                value={value || ''}
                maxLength={maxlength}
                minLength={minlength}
                min={min}
                disabled={disabled}
                onChange={e => onChange(methodModel.isNumber(e))}
            />
                : type == 'badge' ? <>
                    <div className='flex'>
                        <input
                            type="text"
                            className="relative shadow-box border !border-grey bg-white w-full rounded-large h-10 flex items-center gap-2 overflow-hidden px-2"
                            placeholder={placeholder} value={text}
                            onChange={e => setText(e.target.value)}
                        />
                        <button type='button' className='btn btn-[#115B9D] ml-2' onClick={add}>Add</button>
                    </div>
                    <div className=''>
                        {value?.map((itm, i) => {
                            return <span className='badge badge-[#115B9D] m-1'>
                                {itm}
                                <i className='fa fa-times ml-1' onClick={() => remove(i)}></i>
                            </span>
                        })}

                    </div>
                </> : type == 'radio' ? <>
                    <div className='flex flex-wrap gap-3'>
                        {options.map(itm => {
                            return <label className="text-typo cursor-pointer mb-0 text-sm font-medium flex items-center gap-1.5 hover:text-[#115B9D]   group">
                                <input type="radio"
                                    checked={value == itm.id ? true : false}
                                    onChange={e => onChange(itm.id)}
                                    className="h-4 w-4 checked:!ring-[#115B9D] checked:ring-0 ring-offset-1 cursor-pointer shrink-0 rounded-full border-[1.6px] border-[#3C3E4966] group-hover:border-[#115B9D] !text-[#115B9D]  " name={name} disabled={disabled} />
                                {itm.name}</label>
                        })}
                    </div>

                </> : type == 'editor' ? <>
                    <ReactQuill theme="snow"
                        className="quillreacts resize-y overflow-auto min-h-[150px] h-[250px]"

                        value={value}
                        onChange={newValue => {
                            onChange(newValue)
                        }
                        } />
                </> : type == 'checkbox' ? <>
                    {options.map(itm => {
                        return <label className="flex">
                            <input type="checkbox"
                                checked={value?.includes(itm.id) ? true : false}
                                onChange={e => addItem(itm.id)}
                                className="mr-2" disabled={disabled} />
                            {itm.name}</label>
                    })}
                </> : type == 'date' ? <>
                    <input
                        type="date"
                        name={name}
                        className={`relative shadow-box ${error ? 'border-[1.5px] border-red-500' : 'border-[1.5px] border-slate-500'} bg-white w-full rounded-large h-10 flex items-center gap-2 overflow-hidden px-3 outline-none focus:outline-none focus:ring-0 ${error ? 'focus:border-red-500' : 'focus:border-slate-500'} text-sm text-slate-900 ${className}`}
                        required={required}
                        placeholder={placeholder}
                        value={value?.split('T')?.[0]}
                        maxLength={maxlength}
                        minLength={minlength}
                        min={min}
                        disabled={disabled}
                        onChange={e => onChange(e.target.value)}
                    />
                </> : type == 'phone' ? (
                    <div className="relative w-full">
                        <PhoneInput
                            country="us"
                            enableSearch={true}
                            autoFormat={true}
                            disableCountryCode={false}
                            countryCodeEditable={true}
                            specialLabel=""
                            value={value || ''}
                            placeholder={placeholder || '+1 (800) 555-0199'}
                            disabled={disabled}
                            // onChange={(phone, country, e, formattedValue) => {
                            //     const dialCode = country?.dialCode || '1';
                            //     const cleanPhone = (phone || '').replace(/\D/g, '');
                            //     if (!cleanPhone || cleanPhone === dialCode) {
                            //         onChange('');
                            //     } else {
                            //         onChange(formattedValue || (phone ? (phone.startsWith('+') ? phone : `+${phone}`) : ''));
                            //     }
                            // }}
                            onChange={(phone, country, e, formattedValue) => {
                                const cleanPhone = (phone || '').replace(/\D/g, '');

                                if (!cleanPhone) {
                                    onChange('');
                                    return;
                                }

                                onChange(formattedValue || `+${phone}`);
                            }}
                            buttonClass="!border-[1.5px] !border-r-0 !border-slate-500 !bg-slate-50 !rounded-l-large"
                            inputClass={`shadow-box !border-[1.5px] ${error ? '!border-red-500' : '!border-slate-500'} !bg-white !w-full !text-sm !font-semibold !text-slate-900 placeholder:!text-slate-400 !rounded-large !h-10 !flex !items-center !gap-2 !overflow-hidden !px-4 !pl-12 !outline-none focus:!outline-none focus:!ring-0 ${error ? 'focus:!border-red-500' : 'focus:!border-slate-500'} ${className}`}
                            dropdownClass="!rounded-xl !shadow-lg !border !border-slate-300 !text-slate-900"
                        />
                    </div>
                ) : (
                    <div className="relative w-full">
                        <input
                            type={showEye ? (showPassword ? 'text' : 'password') : type}
                            name={name}
                            id={id || name}
                            autoComplete={autoComplete}
                            className={`shadow-box ${error ? 'border-[1.5px] border-red-500' : 'border-[1.5px] border-slate-500'} bg-white w-full text-sm text-slate-900 placeholder:text-slate-500 rounded-large ${className.includes('h-') ? '' : 'h-10'} flex items-center gap-2 overflow-hidden px-4 outline-none focus:outline-none focus:ring-0 ${error ? 'focus:border-red-500' : 'focus:border-slate-500'} ${showEye ? 'pr-11' : ''} ${className}`}
                            required={required}
                            placeholder={placeholder}
                            value={value || ''}
                            maxLength={maxlength}
                            minLength={minlength}
                            min={min}
                            disabled={disabled}
                            onChange={e => onChange(e.target.value)}
                        />
                        {showEye ? (
                            <button
                                type="button"
                                tabIndex={-1}
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute right-3.5 top-1/2 -translate-y-1/2 text-slate-700 hover:text-slate-950 p-1 focus:outline-none cursor-pointer z-10 transition-colors"
                                aria-label={showPassword ? "Hide password" : "Show password"}
                            >
                                {showPassword ? <FaEye className="w-4 h-4" /> : <FaEyeSlash className="w-4 h-4" />}
                            </button>
                        ) : null}
                    </div>
                )
            }

            {error ? <>
                <div className='text-red-500 text-xs mt-1.5 font-medium'>{error}</div>
            </> : <></>}
        </div>
    </>
}